import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Building2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FormField } from "@/components/FormBits";
import { api, formatError } from "@/lib/api";

const FIELDS = [["name", "Nome da empresa", true], ["cnpj", "CNPJ", false], ["address", "Endereço", false], ["phone", "Telefone", false], ["email", "E-mail", false]];

export default function AdminCompany() {
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/admin/company").then(({ data }) => { const { defaults, ...rest } = data; setF(rest); }).catch((e) => toast.error(formatError(e)));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.put("/admin/company", f);
      toast.success("Dados da empresa salvos");
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setBusy(false);
    }
  };

  if (!f) return null;
  return (
    <div className="max-w-xl space-y-6">
      <div>
        <h1 className="font-display text-3xl font-extrabold tracking-tight">Dados da empresa</h1>
        <p className="text-slate-500">Aparecem no topo de todas as notas de serviço em PDF.</p>
      </div>
      <form onSubmit={save} className="space-y-4 rounded-md border border-slate-200 bg-white p-6" data-testid="company-form">
        <h2 className="flex items-center gap-2 font-display text-lg font-bold"><Building2 className="h-5 w-5 text-[#0099DD]" /> Empresa emissora</h2>
        {FIELDS.map(([k, label, required]) => (
          <FormField key={k} id={`company-${k}`} label={label} required={required} value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} />
        ))}
        <Button type="submit" disabled={busy} className="bg-[#0099DD] hover:bg-sky-700" data-testid="btn-save-company">{busy ? "Salvando..." : "Salvar dados"}</Button>
      </form>
    </div>
  );
}
